/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useContext } from 'react';

export const PageContext = createContext<any>({});

export const usePageContext = () => {
  return useContext(PageContext);
};
